import React, { useEffect } from 'react';
import commonService from 'utils/commonService';
import { Postcode } from 'bff/models/info';
import { STEP } from './types';
import PreviewPlanTable from './PreviewPlanTable';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import moment from 'moment';
import apiCommonService from 'bff/services/commonService';
import environment from 'constants/environments';
import { InsuredRelation } from 'constants/enums/insuredRelation.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

type IProps = {
  handleStep: (step: STEP) => void;
  state: any;
  setState: any;
  postcodes: Postcode[];
  handleFetchOTP: (isReSent?: boolean, policyAddReq?: any) => void;
}

const PreviewPet: React.FC<IProps> = (props) => {
  /**
   * @description 點選下一步事件
  */
  // 執行 新增保單資料API

  // console.warn('props.form2', form2);
  const policy = props.state.validReq.RULECHECK;
  const product = props.state.selectedCalcPlan;

  const addPolicy = async () => {
    // 新增保單
    const serverTimeMs = await apiCommonService.fetchSysTime();

    const validReq = props.state.validReq2;
    const validRes = props.state.validRes;
    const programId = storageService.getItem(storageKeys.PetProgramCode);
    const channelId = storageService.getItem(storageKeys.ChannelId);

    const addReq = {
      PET_POLICY: {
        CHANNEL_ID: channelId || null,
        BC_TYPE: validReq.RULECHECK.BC_TYPE,
        APPLY_TIME: commonService.formatUtcTime(serverTimeMs).format('YYYY-MM-DD HH:mm:ss.SSS'),
        APPLY_NO: validReq.RULECHECK.APPLY_NO,
        REPOLICY_NO: props.state.repolicyNo ? props.state.repolicyNo : null,
        INS_TYPE_ID: validReq.RULECHECK.INS_TYPE_ID,
        PROD_ID: validReq.RULECHECK.PROD_ID,
        PLAN_ID: props.state.selectedCalcPlan.PLAN_ID,
        PROGRAM_ID: programId || environment.defaultProgramId,
        START_DATE: validReq.RULECHECK.START_DATE,
        END_DATE: props.state.endDate,
        PET_CHIP: validReq.RULECHECK.PET_CHIP,
        PET_NAME: validReq.RULECHECK.PET_NAME,
        PET_KIND: validReq.RULECHECK.PET_KIND,
        PET_VAR_NO: validReq.RULECHECK.PET_VAR_NO,
        PET_VAR_NAME: validReq.RULECHECK.PET_VAR_NAME,
        PET_VAR_TYPE: props.state.petVarType,
        PET_BDAY: validReq.RULECHECK.PET_BDAY,
        PET_AGE_Y: props.state.petAgeY.toString(),
        PET_AGE_MM: props.state.petAgeMM.toString(),
        PET_POLICY_AGE: props.state.petPolicyAge.toString(),
        PET_VACCINATION: validReq.RULECHECK.PET_VACCINATION,
        PET_SEX: validReq.RULECHECK.PET_SEX,
        PET_WEIGHT: props.state.petWeight,
        PET_STERIL: validReq.RULECHECK.PET_STERIL,
        INJURY_STATUS: validReq.RULECHECK.KYC_DATA.filter((data: any) => data.KYC_ID === 'KYCN02')[0].KYC_ANSWER,
        INJURY: validReq.RULECHECK.KYC_DATA.filter((data: any) => data.KYC_ID === 'KYCN02')[0].KYC_OTHER,
        OTHER_POLICY: validReq.RULECHECK.KYC_DATA.filter((data: any) => data.KYC_ID === 'KYCQ01')[0].KYC_ANSWER,
        HEALTH_AGREE_TIME_TERMS: commonService.formatUtcTime(serverTimeMs).format('YYYY-MM-DD HH:mm:ss.SSS'),
        AGREE_TIME_TERMS: commonService.formatUtcTime(props.state.ALL_CONTRACT_CHECKED_TIME).format('YYYY-MM-DD HH:mm:ss.SSS'),
        APPLICANT_ID: validReq.RULECHECK.INSURED_DATA.ID,
        APPLICANT_NAME: validReq.RULECHECK.INSURED_DATA.NAME,
        APPLICANT_ID_TYPE: validReq.RULECHECK.INSURED_DATA.ID_TYPE,
        APPLICANT_BIRTHDAY: validReq.RULECHECK.INSURED_DATA.BIRTHDAY,
        APPLICANT_MOBILE: validReq.RULECHECK.INSURED_DATA.MOBILE,
        APPLICANT_EMAIL: validReq.RULECHECK.INSURED_DATA.MAIL,
        APPLICANT_POSTCODE: props.state.POST_CODE,
        APPLICANT_CITY_ID: props.state.CITY_ID,
        APPLICANT_AREA_ID: props.state.AREA_ID,
        APPLICANT_ADDRESS: props.state.ADDRESS,
        APPLICANT_OCC_DOMAIN: validReq.RULECHECK.INSURED_DATA.OCP_TYPE,
        APPLICANT_TYPE: InsuredRelation.Self,
        APPLICANT_MONEY_LAUNDERING: validRes.TRANRS.RULECHECK.COMMONCHECK[0].MONEY_LAUNDER_CORE ? '0' : '1',
        INSURED_ID: validReq.RULECHECK.INSURED_DATA.ID,
        INSURED_NAME: validReq.RULECHECK.INSURED_DATA.NAME,
        INSURED_ID_TYPE: validReq.RULECHECK.INSURED_DATA.ID_TYPE,
        INSURED_BIRTHDAY: validReq.RULECHECK.INSURED_DATA.BIRTHDAY,
        INSURED_MOBILE: validReq.RULECHECK.INSURED_DATA.MOBILE,
        INSURED_EMAIL: validReq.RULECHECK.INSURED_DATA.MAIL,
        INSURED_POSTCODE: props.state.POST_CODE,
        INSURED_CITY_ID: props.state.CITY_ID,
        INSURED_AREA_ID: props.state.AREA_ID,
        INSURED_ADDRESS: props.state.ADDRESS,
        INSURED_OCC_DOMAIN: validReq.RULECHECK.INSURED_DATA.OCP_TYPE,
        INSURED_MONEY_LAUNDERING: validRes.TRANRS.RULECHECK.COMMONCHECK[0].MONEY_LAUNDER_CORE ? '0' : '1',
        POLICY_DELIVERY: props.state.delivery,
        PAY_BY: '0',
        PAYMENT_STATUS: '0',
        TOTAL_FEE: validReq.RULECHECK.INSURED_DATA.FEE,
        PET_PIC: props.state.petPic,
        DEPARTMENT: '00',
        OPERATOR: props.state.programId || '',
        QUOTE_OID: props.state.selectedCalcPlan.QUOTE_OID
      },
      PET_PRODUCT: {
        APPLY_NO: validReq.RULECHECK.APPLY_NO,
        PROD_ID: validReq.RULECHECK.PROD_ID,
        TOTAL_FEE: validReq.RULECHECK.INSURED_DATA.FEE,
        AMOUNT1: props.state.selectedCalcPlan.AMOUNT1,
        AMOUNT2: props.state.selectedCalcPlan.AMOUNT2,
        AMOUNT3: props.state.selectedCalcPlan.AMOUNT3,
        AMOUNT4: props.state.selectedCalcPlan.AMOUNT4,
        AMOUNT5: props.state.selectedCalcPlan.AMOUNT5,
        AMOUNT6: props.state.selectedCalcPlan.AMOUNT6,
        AMOUNT7: props.state.selectedCalcPlan.AMOUNT7,
        AMOUNT8: props.state.selectedCalcPlan.AMOUNT8,
        AMOUNT9: props.state.selectedCalcPlan.AMOUNT9,
        AMOUNT10: props.state.selectedCalcPlan.AMOUNT10,
        AMOUNT11: props.state.selectedCalcPlan.AMOUNT11,
        AMOUNT12: props.state.selectedCalcPlan.AMOUNT12,
        DEDUCTIBLE1: props.state.selectedCalcPlan.DEDUCTIBLE1,
        DEDUCTIBLE2: props.state.selectedCalcPlan.DEDUCTIBLE2,
        DEDUCTIBLE3: props.state.selectedCalcPlan.DEDUCTIBLE3,
        DEDUCTIBLE4: props.state.selectedCalcPlan.DEDUCTIBLE4,
        DEDUCTIBLE5: props.state.selectedCalcPlan.DEDUCTIBLE5,
        DEDUCTIBLE6: props.state.selectedCalcPlan.DEDUCTIBLE6,
        DEDUCTIBLE7: props.state.selectedCalcPlan.DEDUCTIBLE7,
        DEDUCTIBLE8: props.state.selectedCalcPlan.DEDUCTIBLE8,
        DEDUCTIBLE9: props.state.selectedCalcPlan.DEDUCTIBLE9,
        FREQUENCY1: props.state.selectedCalcPlan.FREQUENCY1,
        FREQUENCY2: props.state.selectedCalcPlan.FREQUENCY2,
        FREQUENCY3: props.state.selectedCalcPlan.FREQUENCY3
      },
      KYC_LIST: validReq.RULECHECK.KYC_DATA.map((kycData: any) => {
        return {
          ...kycData,
          APPLY_NO: validReq.RULECHECK.APPLY_NO,
          ASSURER_ID: validReq.RULECHECK.INSURED_DATA.ID
        };
      })
    };

    props.setState((prev: any) => ({
      ...prev,
      addReq
    }));

    const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
    const tempData = {
      ...originTempData,
      addReq: addReq
    };
    commonService.storageData(storageKeys.InsurceProcessPetState, tempData);

    props.handleFetchOTP(false, addReq);
  };

  useEffect(() => {
    commonService.scrollToTop();
  }, []);

  return (
    <div className="insure-process-preview">
      <div className="insure-process-preview__content">
        <div className="insured-info">
          <div className="insured-info__title">保障範圍</div>
          <div className="insure-rules" style={{ padding: 0 }}>
            <PreviewPlanTable
              product={product}
              startDate={policy.START_DATE}
            />
          </div>
        </div>
        <div className="insured-info">
          <div className="insured-info__title">寵物資料</div>
          <div className="policyholder-info__content">
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">寵物名字</div>
                  <div className="element__list-group-content">{policy?.PET_NAME}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">品種</div>
                  <div className="element__list-group-content">{policy?.PET_VAR_NAME}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">種類</div>
                  <div className="element__list-group-content">{policy?.PET_KIND === '1' ? '貓' : policy?.PET_KIND === '0' ? '狗' : ''}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">性別</div>
                  <div className="element__list-group-content">{policy?.PET_SEX === '0' ? '母' : policy?.PET_SEX === '1' ? '公' : ''}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">是否絕育</div>
                  <div className="element__list-group-content">{policy?.PET_STERIL === '0' ? '否' : policy?.PET_STERIL === '1' ? '是' : ''}</div>
                </div>
              </div>
            </div>
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">晶片序號</div>
                  <div className="element__list-group-content">{policy?.PET_CHIP}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">出生日期</div>
                  <div className="element__list-group-content">{moment(policy?.PET_BDAY).format('YYYY年MM月')}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">年齡</div>
                  <div className="element__list-group-content">{props.state.petAgeY === '0' ? '' : (props.state.petAgeY + '歲')}{props.state.petAgeMM}個月</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">體重</div>
                  <div className="element__list-group-content">{props.state.petWeight}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="policyholder-info">
          <div className="policyholder-info__title">要保人資料</div>
          <div className="policyholder-info__content">
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">證件類別</div>
                  <div className="element__list-group-content">身分證</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">姓名</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.NAME}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">出生年月日</div>
                  <div className="element__list-group-content">{moment(policy?.INSURED_DATA.BIRTHDAY).format('YYYY年MM月DD日')}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">手機</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.MOBILE}</div>
                </div>
              </div>
            </div>
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">通訊地址</div>
                  <div className="element__list-group-content">
                    {
                      `${props.state.POST_CODE}${commonService.getCityName(props.postcodes, props.state.CITY_ID)}${commonService.getAreaName(props.postcodes, props.state.CITY_ID, props.state.AREA_ID)}${props.state.ADDRESS}`
                    }
                  </div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">職業類別</div>
                  <div className="element__list-group-content">
                    <span className="occupation-domain">{props.state.OCCUPATION_DOMAIN_ID === OccupationIdType.Normal ? '一般職業' : props.state.OCCUPATION_DOMAIN_ID === OccupationIdType.Special ? '非一般職業' : ''}</span>
                    <span>{props.state.OCCUPATION_ID_NAME}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">身分證字號</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.ID}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">性別</div>
                  <div className="element__list-group-content">{props.state.GENDER === 'F' ? '女' : props.state.GENDER === 'M' ? '男' : ''}</div>
                </div>
              </div>
              <div className="element__list-col" style={{ flexBasis: 'content' }}>
                <div className="element__list-group">
                  <div className="element__list-group-title">電子信箱</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.MAIL}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="policyholder-info">
          <div className="policyholder-info__title">被保險人資料</div>
          <div className="policyholder-info__content">
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">證件類別</div>
                  <div className="element__list-group-content">身分證</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">姓名</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.NAME}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">出生年月日</div>
                  <div className="element__list-group-content">{moment(policy?.INSURED_DATA.BIRTHDAY).format('YYYY年MM月DD日')}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">手機</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.MOBILE}</div>
                </div>
              </div>
            </div>
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">通訊地址</div>
                  <div className="element__list-group-content">
                    {
                      `${props.state.POST_CODE}${commonService.getCityName(props.postcodes, props.state.CITY_ID)}${commonService.getAreaName(props.postcodes, props.state.CITY_ID, props.state.AREA_ID)}${props.state.ADDRESS}`
                    }
                  </div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">職業類別</div>
                  <div className="element__list-group-content">
                    <span className="occupation-domain">{props.state.OCCUPATION_DOMAIN_ID === OccupationIdType.Normal ? '一般職業' : props.state.OCCUPATION_DOMAIN_ID === OccupationIdType.Special ? '非一般職業' : ''}</span>
                    <span>{props.state.OCCUPATION_ID_NAME}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="element__list" style={{ justifyContent: 'space-between' }}>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">身分證字號</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.ID}</div>
                </div>
              </div>
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">性別</div>
                  <div className="element__list-group-content">{props.state.GENDER === 'F' ? '女' : props.state.GENDER === 'M' ? '男' : ''}</div>
                </div>
              </div>
              <div className="element__list-col" style={{ flexBasis: 'content' }}>
                <div className="element__list-group">
                  <div className="element__list-group-title">電子信箱</div>
                  <div className="element__list-group-content">{policy?.INSURED_DATA.MAIL}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="delivery">
          <div className="delivery__title">保單寄送方式</div>
          <div className="delivery__content">
            <div className="element__list">
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">保單寄送方式</div>
                  <div className="element__list-group-content">
                    電子保單 email
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="insure-process-preview__controls">
        <button type="button" className="element__button element__button--red-border" onClick={() => props.handleStep(STEP.infoCheck)}>返回上一頁</button>
        <button
          type="button"
          className="element__button element__button--red"
          onClick={addPolicy}
        >
          下一步
        </button>
      </div>
    </div>
  );
};

export default PreviewPet;
